import h from 'react-hyperscript';
import './ErrorMessage.scss';
import {h2, subhead} from 'Components/Typography/Typography';
import content from 'Assets/data/globals.json';

const ErrorMessage = (props) => {
  return (
    h('div', {
      className: 'error-message error-message--full',
    },
    h('div', null, [
      h(h2, {
        key: 'error-title__key',
        className: 'text--grey text--center',
      }, props.prefix || content.errors.prefix),
      h(subhead, {
        className: 'text--grey text--center padding-top--md',
      }, props.message),
    ])
    )
  );
};

export default ErrorMessage;
